import React, { useEffect } from 'react';

const InRoomDiningTagViewDetail = ({ tag }) => {
  useEffect(() => {}, [tag]);

  return (
    <div className='row mx-4 mt-4'>
      {
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Tag Name</div>
            <div className='details-value preview-breaks'>{tag.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label text-center'>Status</div>
            <div
              className={`${
                tag.status ? 'pill-active' : 'pill-inactive'
              } col-md-3 pill-text pill container`}
            >
              <span>{tag.status ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Tag Code</div>
            <div className='details-value'>{tag.code}</div>
          </div>
          {tag?.customAttributes &&
            tag?.customAttributes?.length > 0 &&
            tag?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      }
    </div>
  );
};

export default InRoomDiningTagViewDetail;
